import projectImage960 from '../../assets/images/responsive/boundary-960.webp';
import projectImage1440 from '../../assets/images/responsive/boundary-1440.webp';
import projectImage1920 from '../../assets/images/responsive/boundary-1920.webp';
import styles from './AboutProject.module.scss';

export function AboutProject() {
  return (
    <section className={styles.about} id="village" aria-labelledby="about-title">
      <div className={styles.inner}>
        <div className={styles.copy} data-reveal>
          <p className={styles.eyebrow}>О Лучезарной Долине</p>
          <h2 id="about-title">Посёлок для постоянной жизни</h2>
          <div className={styles.lead}>
            <p>
              Лучезарная Долина — действующий коттеджный посёлок в деревне Низино Ломоносовского
              района. Он рассчитан на 160 домовладений с просторными участками для индивидуального
              жилищного строительства.
            </p>
            <p>
              Посёлок развивается не только как территория с земельными участками, но
              и как настоящее загородное сообщество.
            </p>
          </div>
          <ul className={styles.facts} aria-label="Лучезарная Долина в цифрах">
            <li>
              <strong>160</strong>
              <span>домовладений</span>
            </li>
            <li>
              <strong>~20%</strong>
              <span>семей живут постоянно</span>
            </li>
            <li>
              <strong>~30%</strong>
              <span>домов строятся</span>
            </li>
            <li>
              <strong>3 км</strong>
              <span>до КАД</span>
            </li>
          </ul>
        </div>

        <figure className={styles.media} data-reveal="media" data-reveal-delay="1">
          <img
            src={projectImage1440}
            srcSet={`${projectImage960} 960w, ${projectImage1440} 1440w, ${projectImage1920} 1920w`}
            sizes="(max-width: 1023px) calc(100vw - 40px), 60vw"
            width="1920"
            height="1080"
            alt="Аэрофотосъёмка Лучезарной Долины с обозначенной границей территории посёлка"
            loading="lazy"
            decoding="async"
          />
        </figure>
      </div>
    </section>
  );
}
